const keys = {
    SESSION_KEY:'session',
    BEFORELOFINHREF:'beforeLogin', // 当前操作页面
}

export default keys;